import { Chip, Skeleton, Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import React from 'react';
import { ImageContainer } from '../DrawerStyles';
import { ResultStatus } from '@dispatch/shared/types';
import { TabContainerProps } from '../../tab-component/TabContainer';

/**
 * AvatarLayout is used when a avatar profile image is needed.
 */
export const AvatarLayout = ({
  title,
  subtitle,
  showIsActive,
  isActive,
  renderMeta,
  status,
  imageUrl,
  metas,
  renderTabs,
}: {
  title?: string;
  subtitle?: string;
  showIsActive?: boolean;
  isActive?: boolean;
  renderMeta?: () => React.ReactNode[] | undefined;
  status?: ResultStatus;
  imageUrl?: string;
  metas?: React.ReactNode[];
  renderTabs?: React.ReactElement<TabContainerProps>;
}) => {
  const renderAvatar = () => {
    return imageUrl !== ' ' ? (
      <ImageContainer>
        <img
          style={{
            objectFit: 'cover',
            objectPosition: 'center center',
            width: '100%',
            height: '100%',
          }}
          src={imageUrl || ''}
          alt="Profile Avatar"
        />
      </ImageContainer>
    ) : (
      <AccountCircleIcon
        style={{ fontSize: '100px', marginRight: '1.5625rem' }}
      />
    );
  };
  return (
    <Stack>
      <Stack direction="row" padding={2} alignItems="center">
        {imageUrl && renderAvatar()}
        <Stack width="100%">
          <Stack
            direction="row"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            paddingBottom={2}
          >
            <div>
              <Typography
                data-testid="drawer-title"
                variant="h2"
                sx={{
                  margin: 0,
                  fontSize: '1rem',
                  fontFamily: '"Roboto", sans-serif',
                  fontWeight: '400',
                  color: '#cccff8',
                  textTransform: 'uppercase',
                }}
              >
                {status === 'loading' ? (
                  <Skeleton width="10em" height="2em" sx={{ margin: 0 }} />
                ) : (
                  title
                )}
              </Typography>
              {subtitle && (
                <Typography
                  data-testid="drawer-subtitle"
                  variant="h2"
                  sx={{
                    margin: 0,
                    fontFamily: '"Roboto", sans-serif',
                    fontSize: '0.625rem',
                    fontWeight: '500',
                    color: '#cccff8',
                    textTransform: 'uppercase',
                  }}
                >
                  {status === 'loading' ? (
                    <Skeleton width="5em" height="2em" sx={{ margin: 0 }} />
                  ) : (
                    subtitle
                  )}
                </Typography>
              )}
            </div>
            <div>
              {showIsActive && status !== 'loading' && (
                <Chip
                  data-testid="drawer-active"
                  label={isActive ? 'Active' : 'Inactive'}
                  sx={{
                    minWidth: '5em',
                    fontSize: '.85em',
                    color: '#FFFFFF',
                    backgroundColor: isActive ? '#4CAF50' : '#F44336',
                  }}
                />
              )}
            </div>
          </Stack>
          <Stack direction="row" spacing={2}>
            {metas && renderMeta && renderMeta()}
          </Stack>
        </Stack>
      </Stack>
      <Box>{renderTabs}</Box>
    </Stack>
  );
};
